// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"ecaf2434","190":"a271afeb","313":"7d1873e1","675":"e2543bf0"}[chunkId] + ".chunk.js";
};